var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36953e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ab53f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0.181 0.385)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 60,
    cy: 60.5,
    rx: 60,
    ry: 60.5,
    transform: "translate(-0.181 -0.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "headset_1_",
    "data-name": "headset (1)",
    transform: "translate(20.848 30.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(22.656 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4787",
    "data-name": "Path 4787",
    d: "M210.991,55.738a22.4,22.4,0,0,0-13.348-20.161,4.042,4.042,0,0,0-7.619-1.864c-.62-.04-1.244-.057-1.866-.048a22.467,22.467,0,0,0-22.1,22.253l-3.92,12.928a1.4,1.4,0,0,0,1.338,1.8h4.464a.444.444,0,0,1,.444.444v4.684a9.054,9.054,0,0,0,9.044,9.044h1.977a1.736,1.736,0,0,1,1.734,1.734V92.9a1.4,1.4,0,1,0,2.8,0V86.554a4.534,4.534,0,0,0-4.529-4.529h-1.977a6.255,6.255,0,0,1-6.248-6.248V71.093a3.243,3.243,0,0,0-3.239-3.239h-2.579l3.432-11.32a1.393,1.393,0,0,0,.06-.406A19.756,19.756,0,0,1,188.2,36.46c.451-.007.9,0,1.355.025V56.674a8.267,8.267,0,0,0,2.225,15.411,3.256,3.256,0,0,1-3.008,2.018h-5.948a3.984,3.984,0,1,0,0,2.8h5.948a6.057,6.057,0,0,0,5.9-4.745,8.267,8.267,0,0,0,2.964-15.282V38.678A19.615,19.615,0,0,1,208.2,55.786a26.058,26.058,0,0,1-4.311,14.372,11.022,11.022,0,0,0-1.979,6.322V87.464a1.4,1.4,0,0,0,2.8,0V76.48a8.238,8.238,0,0,1,1.479-4.726A28.619,28.619,0,0,0,210.991,55.738ZM179.1,76.69a1.189,1.189,0,1,1,1.189-1.189A1.19,1.19,0,0,1,179.1,76.69Zm13.257-41.1a1.247,1.247,0,0,1,2.495,0V55.836a8.1,8.1,0,0,0-2.495-.054ZM198.9,63.98a5.474,5.474,0,1,1-5.474-5.474A5.48,5.48,0,0,1,198.9,63.98Z",
    transform: "translate(-162.082 -31.551)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(62.48 59.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4788",
    "data-name": "Path 4788",
    d: "M449.366,460.86a1.4,1.4,0,1,0,.41.988A1.4,1.4,0,0,0,449.366,460.86Z",
    transform: "translate(-446.98 -460.45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717",
    transform: "translate(0 2.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    d: "M32.9,47.585a22.6,22.6,0,0,0-6.825-.931A22.467,22.467,0,0,0,3.98,68.907L.061,81.835a1.4,1.4,0,0,0,1.338,1.8H5.862a.444.444,0,0,1,.444.444v4.684A9.054,9.054,0,0,0,15.35,97.81h1.977a1.736,1.736,0,0,1,1.734,1.734v6.346a1.4,1.4,0,1,0,2.8,0V99.543a4.534,4.534,0,0,0-4.529-4.529H15.35A6.255,6.255,0,0,1,9.1,88.766V84.082a3.243,3.243,0,0,0-3.239-3.239H3.283l3.432-11.32a1.393,1.393,0,0,0,.06-.406A19.708,19.708,0,0,1,32.1,50.264a1.4,1.4,0,0,0,.8-2.68Z",
    transform: "translate(0 -46.651)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(13.03 39.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M105.9,320.056h-4.964a3.984,3.984,0,1,0,0,2.8H105.9a1.4,1.4,0,1,0,0-2.8ZM97.2,322.643a1.189,1.189,0,1,1,1.189-1.189A1.19,1.19,0,0,1,97.2,322.643Z",
    transform: "translate(-93.219 -317.47)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721",
    transform: "translate(10.018 23.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M73.066,196.968a1.4,1.4,0,0,0-1.4,1.4v.058a1.4,1.4,0,0,0,2.8,0v-.058A1.4,1.4,0,0,0,73.066,196.968Z",
    transform: "translate(-71.668 -196.968)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723",
    transform: "translate(11.184 8.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M94.9,90.591a16.336,16.336,0,0,0-14.782,9.986,1.4,1.4,0,1,0,2.576,1.086,13.539,13.539,0,0,1,12.251-8.277,1.4,1.4,0,1,0-.045-2.8Z",
    transform: "translate(-80.01 -90.59)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725",
    transform: "translate(33.128 23.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M239.387,197.79a1.4,1.4,0,1,0,.41.988A1.408,1.408,0,0,0,239.387,197.79Z",
    transform: "translate(-237.001 -197.38)",
    fill: "url(#linear-gradient)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9eb3f557e4b675c804fc736811b5be7a.svg";
export { ForwardRef as ReactComponent };